import { useState, useEffect } from "react";
import Select from "react-select";
import {
    addUser,
} from "../../../../../actions/admin/quotation";
import AdminModal from "../../../components/AdminModal";
import AdminInput from "../../../components/AdminInput";
import AdminPhoneNumberInput from "../../../components/AdminPhoneNumberInput";
import AdminPostalCodeInput from "../../../components/AdminPostalCodeInput";
import { POSTAL_CODE_STATUS } from "../../../../input/postal-code";
import { RadioSelectedIcon, RadioUnselectedIcon } from "../../../../icons";

const AddClientModal = ({ show, onClose, onSuccessAddNewClient, onFailedAddNewClient }) => {
    const PRONOUNCE = [
        {
            label: "-",
            value: "-",
        },
        {
            label: "Mr.",
            value: "Mr.",
        },
        {
            label: "Ms.",
            value: "Ms.",
        },
        {
            label: "Mrs.",
            value: "Mrs.",
        },
        {
            label: "Mr./Ms.",
            value: "Mr./Ms.",
        },
    ];

    const [addUserForm, setAddUserForm] = useState({
        type: "individual",
        honorific: "Mr.",
        name: "",
        email: "",
        prefixNumber: "+81",
        phoneNumber: "",
        country: "Japan",
        countryCode: "JP",
        postalCode: "",
        billingAddress: "",
        city: ""
    });
    const [isCityDisable, setIsCityDisable] = useState(true);
    const [isPostalCodeDisable, setIsPostalCodeDisable] = useState(false);
    const [formValidation, setFormValidation] = useState({
        email: true,
        billingAddress: true,
        name: true
    })

    const checkValidation = async () => {
        setFormValidation({
            ...formValidation,
            email: addUserForm.email !== ""
        })

        return (
            addUserForm.email !== ""
        )
    }

    const [postalCodeStatus, setPostalCodeStatus] = useState(POSTAL_CODE_STATUS.IDLE);
    // Bumped on every open so the postal code field starts fresh (see AdminPostalCodeInput).
    const [formSessionKey, setFormSessionKey] = useState(0);

    useEffect(() => {
        if (show) {
            setPostalCodeStatus(POSTAL_CODE_STATUS.IDLE);
            setFormSessionKey((key) => key + 1);
        }
    }, [show]);

    // Hold Save while the postal code is being checked or does not exist.
    const isPostalCodeBlockingSave =
        postalCodeStatus === POSTAL_CODE_STATUS.CHECKING ||
        postalCodeStatus === POSTAL_CODE_STATUS.NOT_FOUND;

    const handleCityFound = (city) => setAddUserForm((prev) => ({ ...prev, city }));
    const handlePostalCodeNotFound = () => setAddUserForm((prev) => ({ ...prev, city: "" }));

    const customStylesSelect = {
        control: (provided) => ({
            ...provided,
            minHeight: "48px",
            height: "38px",
            marginTop: "10px",
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: "38px",
            padding: "0 8px",
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: "38px",
        }),
    };

    const handleChangeNewClientForm = (e) => {
        if (e.target.name === "name" || e.target.name === "billingAddress") {
            const invalidChars = e.target.value.split('').filter(char =>
                !/[\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(char)
            );

            if (e.target.value === "") {
                setFormValidation({
                    ...formValidation,
                    [e.target.name]: true
                })
            } else if (invalidChars.length > 0) {
                setFormValidation({
                    ...formValidation,
                    [e.target.name]: false
                })
            } else {
                setFormValidation({
                    ...formValidation,
                    [e.target.name]: true
                })
            }
        }

        setAddUserForm({ ...addUserForm, [e.target.name]: e.target.value });
    }

    const handleAddUserChangeCountryCode = (dialCode, countryCode, name) => {
        setAddUserForm({
            ...addUserForm,
            country: name,
            countryCode: countryCode,
            prefixNumber: dialCode,
        });
    };

    const submitAddUser = async () => {
        if (isPostalCodeBlockingSave) return;
        try {
            const validationStatus = await checkValidation();

            if (validationStatus) {
                const response = await addUser(addUserForm);
                alert("Success Add Client!");
                setAddUserForm({
                    type: "individual",
                    honorific: "Mr.",
                    name: "",
                    email: "",
                    prefixNumber: "+81",
                    phoneNumber: "",
                    country: "Japan",
                    countryCode: "JP",
                    postalCode: "",
                    billingAddress: "",
                });

                onSuccessAddNewClient(response);
            }
        } catch (e) {
            onFailedAddNewClient(e);
        }
    };

    useEffect(() => {
        const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

        if (!countryWithoutPostCode.split(',').includes(addUserForm.countryCode)) {
            setIsPostalCodeDisable(false);
            setIsCityDisable(true);
            setAddUserForm({
                ...addUserForm,
                postalCode: "",
                city: "",
            })
        } else {
            setAddUserForm({
                ...addUserForm,
                postalCode: "-",
                city: "",
            })
            setIsPostalCodeDisable(true);
            setIsCityDisable(false);
        }
    }, [addUserForm.countryCode]);

    return (
        <AdminModal
            show={show}
            title="Add Client"
            size="modal-lg"
            onClose={onClose}
            description={"Kindly enter the client’s name and address using the Roman alphabet only (e.g., Tanaka Taro)"}
        >
            <div className="row mb-3 px-2">
                <div className="col-6 m-0 p-0 pe-1">
                    <div
                        className={`rounded w-100 ${addUserForm.type === "individual"
                            ? "border-gold"
                            : "border-gold-100"
                            } p-3 pointer hover`}
                        onClick={() => handleChangeNewClientForm({ target: { name: "type", value: "individual" } })}
                    >
                        <div className="d-flex gap-2 align-items-center">
                            {addUserForm.type === "individual"
                                ? <RadioSelectedIcon />
                                : <RadioUnselectedIcon />}
                            <p className={`m-0 ${addUserForm.type === "individual" && "fw-bold"}`}>
                                Individual
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-6 m-0 p-0 ps-1">
                    <div
                        className={`rounded w-100 ${addUserForm.type === "business"
                            ? "border-gold"
                            : "border-gold-100"
                            } p-3 pointer hover`}
                        onClick={() => handleChangeNewClientForm({ target: { name: "type", value: "business" } })}
                    >
                        <div className="d-flex gap-2 align-items-center">
                            {addUserForm.type === "business"
                                ? <RadioSelectedIcon />
                                : <RadioUnselectedIcon />}
                            <p className={`m-0 ${addUserForm.type === "business" && "fw-bold"}`}>
                                Business
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row px-2">
                <div className="col-3 m-0 p-0 pe-1">
                    <p className="mb-2">Honorifics</p>
                    <Select
                        options={PRONOUNCE}
                        onChange={(e) => handleChangeNewClientForm({ target: { name: "honorific", value: e.value } })}
                        styles={customStylesSelect}
                        name="honorific"
                    />
                </div>
                <div className="col m-0 p-0 ps-1">
                    <label className="mb-2 fs-14">Name</label>
                    <AdminInput
                        placeholder="Name"
                        value={addUserForm.name}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="name"
                        isInvalid={!formValidation.name}
                        invalidMessage="Kindly enter the client’s name and address using the Roman alphabet only (e.g., Tanaka Taro)"
                    />
                </div>
            </div>
            <div className="row px-2">
                <div className="col-6 m-0 p-0 pe-1">
                    <label className="mb-2 fs-14">Email</label>
                    <AdminInput
                        placeholder="Email"
                        value={addUserForm.email}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="email"
                        type="email"
                        isInvalid={!formValidation.email}
                        invalidMessage={"Please fill in email address."}
                    />
                </div>
                <div className="col-6 m-0 p-0 ps-1">
                    <label className="mb-2 fs-14">Phone No.</label>
                    <AdminPhoneNumberInput
                        value={addUserForm.phoneNumber}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        countryCode={addUserForm.countryCode}
                        dialCode={addUserForm.prefixNumber}
                        onCountrySelect={handleAddUserChangeCountryCode}
                    />
                </div>
            </div>
            <div className="row px-2">
                <div className="col-4 m-0 p-0 pe-1">
                    <label className="mb-2 fs-14">Country</label>
                    <AdminInput
                        placeholder="Country"
                        value={addUserForm.country}
                        onChange={() => { }}
                        name="country"
                        disable={true}
                    />
                </div>
                <div className="col-4 m-0 p-0 px-1">
                    <label className="mb-2 fs-14">Postal Code</label>
                    <AdminPostalCodeInput
                        key={formSessionKey}
                        value={addUserForm.postalCode}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        countryCode={addUserForm.countryCode}
                        disabled={isPostalCodeDisable}
                        onCityFound={handleCityFound}
                        onPostalCodeNotFound={handlePostalCodeNotFound}
                        onStatusChange={setPostalCodeStatus}
                    />
                </div>
                <div className="col-4 m-0 p-0">
                    <label className="mb-2 fs-14">City</label>
                    <AdminInput
                        placeholder="City"
                        value={addUserForm.city}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="city"
                        disable={isCityDisable}
                    />
                </div>
            </div>
            <div className="row px-2">
                <div className="col-12 m-0 p-0">
                    <label className="mb-2 fs-14">Billing Address</label>
                    <AdminInput
                        placeholder="Billing Address"
                        value={addUserForm.billingAddress}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="billingAddress"
                        isInvalid={!formValidation.billingAddress}
                        invalidMessage="Kindly enter the client’s name and address using the Roman alphabet only (e.g., Tanaka Taro)"
                    />
                </div>
            </div>

            <div className="d-grid mt-3">
                <button
                    className="btn rounded bg-gold py-2"
                    onClick={submitAddUser}
                    disabled={isPostalCodeBlockingSave}
                >
                    <span className="text-white">
                        {postalCodeStatus === POSTAL_CODE_STATUS.CHECKING ? "Checking postal code…" : "Save"}
                    </span>
                </button>
            </div>
        </AdminModal>
    )
}

export default AddClientModal